<template>
    <v-row>
        
        <v-col  cols="6" md="3">
            <v-card depressed class="dashboard-card d-flex justify-center align-center" >
                <div style="position:relative;">
                    <p class="accent--text">total Download</p>
                    <h1>2500</h1>
                </div>
            </v-card>
        </v-col>
        <v-col  cols="6" md="3">
            <v-card depressed class="dashboard-card d-flex justify-center align-center" >
                <div style="position:relative;">
                    <p class="accent--text">Registered Users</p>
                    <h1>{{details.totalUsers}}</h1>
                </div>
            </v-card>
        </v-col>
        <v-col  cols="6" md="3">
            <v-card depressed class="dashboard-card d-flex justify-center align-center" >
                <div style="position:relative;">
                    <p class="accent--text">Active Users</p>
                    <h1>{{details.totalActiveUsers}}</h1>
                </div>
            </v-card>
        </v-col>
        <v-col  cols="6" md="3">
            <v-card depressed class="dashboard-card d-flex justify-center align-center" >
                <div style="position:relative;">
                    <p class="accent--text">Inactive Users</p>
                    <h1>{{details.totalInactiveUsers}}</h1>
                </div>
            </v-card>
        </v-col>
       
    </v-row>
</template>

<script>
export default {
    data:() => ({
        background : ['dashboard-card__one','dashboard-card__two','dashboard-card__three']
    }),
    props:{
        details: Object
    }
}
</script>

<style lang="scss" scoped>
.dashboard-card{
    padding: 25px 0px;
    color:var(--black) !important;
    border-radius: 0px !important;
    min-height: 150px;
    box-shadow: none !important;
    p{
        margin-bottom:10px;
        font-size: 16px;
    }
    h1{
        margin-bottom: 10px;
        font-size: 25px;
        font-weight: 600;
    }
    .card-shadow{
        height:50px;
        opacity: 0.5;
        filter: blur(25px);
        border-radius: 20px;
        position:absolute;
        bottom:0;
        margin-left:auto;
        margin-right:auto;
        right:0;
        left:0;
        width:60%
    }
}

// CARD SPECIAL COLORS 
// .dashboard-card__one{
//     background: linear-gradient(
//     180deg,
//     rgba(232, 80, 40, 1) 0%,
//     rgb(240, 105, 38) 100%
//     );
//     .card-shadow{
//         background: #FF83A6;
//     }
// }
.dashboard-card__two{
    border-right: 2px solid var(--orange);
    border-left: 2px solid var(--orange);
}

// .dashboard-card__three{
//     background: linear-gradient(180deg, #636366 0%, #636366c9 100%);
//     .card-shadow{
//         background: #63CD9E;
//     }
// }
</style>